import api from "../http";

export default class ApiSearch {
  static async getApiSearch(url, text) {
    const params = {
      text: text
    };
    return api.get(url, {params})
  }
}